import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

const useRecaptcha = (siteKey, setRecaptchaLoadingError) => {
  const { i18n } = useTranslation()
  const [recaptchaCompleted, setRecaptchaCompleted] = useState(false)
  const handleRecaptchaCompletion = () => setRecaptchaCompleted(true)
  const getRecaptchaToken = () => window.grecaptcha?.enterprise.getResponse()
  const resetRecaptcha = () => window.grecaptcha?.enterprise.reset()

  useEffect(() => {
    if (siteKey) {
      const script = document.createElement('script')
      script.src = `https://www.google.com/recaptcha/enterprise.js?render=explicit`
      script.async = true
      script.defer = true
      document.body.appendChild(script)

      script.onload = () => {
        window.grecaptcha.enterprise.ready(() => {
          window.grecaptcha.enterprise.render('recaptcha', {
            sitekey: siteKey,
            action: 'LOGIN',
            hl: i18n.language,
            callback: handleRecaptchaCompletion,
          })
        })
      }

      script.onerror = () => {
        setRecaptchaLoadingError(true)
      }

      return () => {
        document.body.removeChild(script)
      }
    }
    // eslint-disable-next-line
  }, [siteKey])

  return { recaptchaCompleted, handleRecaptchaCompletion, getRecaptchaToken, resetRecaptcha }
}

export default useRecaptcha
